import { DEFAULT_DIAL_CODE, onlyDigits, toWhatsAppNumber } from '@/lib/phoneDigits'
import type { CompanyConfig } from '@/pages/Companies/GetCompany/types/config'

export const SITE_CONTACT_MODES = ['chat', 'whatsapp', 'none'] as const

export type SiteContactMode = (typeof SITE_CONTACT_MODES)[number]

export const DEFAULT_WHATSAPP_MESSAGE = 'Olá! Vim pelo site e gostaria de mais informações.'

export const WHATSAPP_MESSAGE_MAX = 500

export function isSiteContactMode(value: string): value is SiteContactMode {
  return (SITE_CONTACT_MODES as readonly string[]).includes(value)
}

export function siteContactMode(config: Pick<CompanyConfig, 'chat' | 'whatsappButton'>): SiteContactMode {
  if (config.chat?.enabled) return 'chat'
  if (config.whatsappButton?.enabled) return 'whatsapp'
  return 'none'
}

export function isValidWhatsAppPhone(phone: string, countryCode: string): boolean {
  const digits = onlyDigits(phone)
  if (countryCode === DEFAULT_DIAL_CODE) return digits.length === 10 || digits.length === 11
  const total = toWhatsAppNumber(digits, countryCode).length
  return digits.length >= 4 && total >= 8 && total <= 15
}

export function whatsAppLink(number: string, message: string): string {
  return `https://wa.me/${number}?text=${encodeURIComponent(message.trim() || DEFAULT_WHATSAPP_MESSAGE)}`
}
